import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import { useLayoutEffect, useRef, useState } from 'react';
import { useWindowDimensions } from '../../hooks';
import { opTypeFormater } from '../../Shared/colorFormat';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { rotateImage } from '../../common/helpers';
import MyIcon from '../../Shared/MyIcon';

function ImageView({ images, doc, setAttachments }: any) {
  const [width, setWidth] = useState(0);
  const { height } = useWindowDimensions();
  const ref = useRef(null);

  useLayoutEffect(() => {
    setWidth(ref.current.offsetWidth);
  }, []);

  const rotImage = (image: any) => {
    const newlist = images.map((img: any) => {
      if (img === image) {
        const rimage = rotateImage(image, 90);
        console.log('rimage', rimage);
        return rimage;
      } else {
        return img;
      }
    });
    setAttachments(newlist);
  };
  const rotBackImage = (image: any) => {
    const newlist = images.map((img: any) => {
      if (img === image) {
        const rimage = rotateImage(image, 90, 'back');
        console.log('rimage', rimage);
        return rimage;
      } else {
        return img;
      }
    });
    setAttachments(newlist);
  };

  return (
    <div ref={ref} style={{ width: '100%' }}>
      <Box p={1}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold' }}>
              {opTypeFormater(doc?.opType)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold' }}>
              {doc?.stepName}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>{doc?.desc}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>{doc?.stepDesc}</Typography>
          </Grid>
        </Grid>
      </Box>
      <Paper style={{ height: height - 250, overflow: 'auto' }} elevation={5}>
        <TransformWrapper>
          <TransformComponent>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {images.map((src: any, index: any) => (
                <Box>
                  {setAttachments && (
                    <Box display={'flex'}>
                      <Button onClick={() => rotBackImage(src)}>
                        <MyIcon icon="left"></MyIcon>
                      </Button>
                      <Button onClick={() => rotImage(src)}>
                        <MyIcon icon="right"></MyIcon>
                      </Button>
                    </Box>
                  )}
                  <img
                    src={src}
                    key={index}
                    style={{
                      overflow: 'hidden',
                      objectFit: 'cover',
                      width: width - 10,
                    }}
                    alt=""
                  />
                </Box>
              ))}
            </div>
          </TransformComponent>
        </TransformWrapper>
      </Paper>
    </div>
  );
}

export default ImageView;
